import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SELECT_POSITIONS, UPCOMING_LOCALE } from "./constants";
import { OptionLinkContainer, MenuWrapper, OptionLink } from "./language-switcher.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var LanguagesMenu = function LanguagesMenu(_ref) {
  var options = _ref.options,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen,
    onLanguageSwitcherOptionClick = _ref.onLanguageSwitcherOptionClick,
    position = _ref.position;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isFirstLanguageSelected = _useState2[0],
    setIsFirstLanguageSelected = _useState2[1];
  var handleClickOutside = useCallback(function () {
    return setIsOpen(false);
  }, [setIsOpen]);
  useEffect(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);
  var handleMouseEnter = useCallback(function (event) {
    event.currentTarget.focus({
      preventScroll: true
    });
    setIsFirstLanguageSelected(false);
  }, []);
  var handleMouseLeave = useCallback(function (event) {
    event.currentTarget.blur();
    setIsFirstLanguageSelected(false);
  }, []);
  var handleOptionClick = useCallback(function (option) {
    return function (event) {
      onLanguageSwitcherOptionClick({
        option: option,
        event: event
      });
    };
  }, [onLanguageSwitcherOptionClick]);
  return /*#__PURE__*/_jsx(MenuWrapper, {
    role: "menu",
    isOpen: isOpen,
    position: position,
    children: options.map(function (_ref2, index) {
      var href = _ref2.href,
        label = _ref2.label,
        locale = _ref2.locale;
      var rel = Object.keys(UPCOMING_LOCALE).includes(locale) ? 'noindex,nofollow' : undefined;
      return /*#__PURE__*/_jsx(OptionLinkContainer, {
        as: "a",
        href: href,
        onClick: handleOptionClick({
          href: href,
          label: label,
          locale: locale
        }),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        isFirstLanguageSelected: isFirstLanguageSelected && index === 0,
        role: "menuitem",
        "data-testid": "language-item",
        rel: rel,
        children: /*#__PURE__*/_jsx(OptionLink, {
          href: href,
          children: label
        }, locale)
      }, label);
    })
  });
};
LanguagesMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    locale: PropTypes.string,
    label: PropTypes.string,
    href: PropTypes.string
  }).isRequired).isRequired,
  isOpen: PropTypes.bool.isRequired,
  position: PropTypes.oneOf(Object.values(SELECT_POSITIONS)).isRequired,
  setIsOpen: PropTypes.func.isRequired,
  onLanguageSwitcherOptionClick: PropTypes.func.isRequired
};
LanguagesMenu.displayName = 'LanguagesMenu';
export default LanguagesMenu;